// src/pages/OurCulture.jsx
import React from "react";
import { useLangTranslation } from "../utils/translation";

export default function OurCulture() {
  const t = useLangTranslation('ourculture');

  const cultureValues = [
    { key: 'ownership' },
    { key: 'focus' },
    { key: 'respect' },
    { key: 'playfulness' },
    { key: 'growth' },
  ];

  return (
    <section className="culture-section">
      {/* Hero 섹션 */}
      <div className="culture-hero">
        <div className="culture-hero-content">
          <h1 className="culture-title">{t('hero.title')}</h1>
          <p className="culture-subtitle">{t('hero.subtitle')}</p>
          <p className="culture-tagline">{t('hero.tagline')}</p>
        </div>
      </div>

      {/* 본문 섹션 */}
      <div className="culture-content">
        <div className="culture-intro">
          <blockquote className="culture-quote">
            {t('quote.text')}
          </blockquote>
        </div>

        {/* 가치관 그리드 */}
        <div className="culture-values">
          {cultureValues.map((value, index) => (
            <div key={index} className="culture-value-card">
              <h3 className="culture-value-keyword">{t(`values.${value.key}.keyword`)}</h3>
              <p className="culture-value-description">{t(`values.${value.key}.description`)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

